<script>
import baseMixin from '@/mixins/baseMixin'
import { DateField } from '@/models/forms/fields/dateField'
import dayjs from '@/services/date/index'
import DateFormatToken from '@/constants/date/DateFormatToken'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionDateField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: DateField,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    compDate() {
      if (!this.value) return ''
      return dayjs(this.value).format(DateFormatToken.LL)
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span class="font-weight-medium">{{ compDate }}</span>
    </InfoLabel>
  </div>
</template>
